import { Grid, Menu, MenuItem } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";
import { SAppBar, SLink, SLogoImg, SMenuItem, SToolbar } from "./styles";
import { LocaleConfigsSelector } from "../shared";

export const NavBar: React.FC = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  const [menuAnchor, setMenuAnchor] = useState(
    null as null | (EventTarget & Element)
  );
  const isOpen = Boolean(menuAnchor);

  const handleClick: React.MouseEventHandler = (event): void => {
    setMenuAnchor(event.currentTarget);
  };

  const handleCloseMenu = (): void => {
    setMenuAnchor(null);
  };

  return (
    <SAppBar position="sticky">
      <SToolbar>
        {theme.logo.show === true && (
          <SLogoImg src={theme.logo.img} alt="logo" />
        )}
        <Grid container spacing={0}>
          <Grid item>
            <SMenuItem color="inherit">{t("navCompareAssets")}</SMenuItem>
          </Grid>
          <Grid item>
            <SMenuItem id="nav-button" onClick={handleClick}>
              {t("navComparePortfolio")}
            </SMenuItem>
            <Menu
              id="nav-menu"
              anchorEl={menuAnchor}
              open={isOpen}
              onClose={handleCloseMenu}
              aria-controls={isOpen ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={isOpen ? "true" : undefined}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "center" }}
              MenuListProps={{
                "aria-labelledby": "nav-button",
              }}
            >
              <MenuItem onClick={handleCloseMenu}>
                <SLink to="/">{t("pathPortfolioComposition")}</SLink>
              </MenuItem>
              <MenuItem onClick={handleCloseMenu}>
                <SLink to="/editor">{t("pathEditor")}</SLink>
              </MenuItem>
              <MenuItem onClick={handleCloseMenu}>
                <SLink to="/analysis">{t("pathAnalysis")}</SLink>
              </MenuItem>
            </Menu>
          </Grid>
          <Grid item>
            <SMenuItem color="inherit">{t("navMonitoring")}</SMenuItem>
          </Grid>
        </Grid>
        <LocaleConfigsSelector />
      </SToolbar>
    </SAppBar>
  );
};
